// no longer being used

class Newsletter extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector(".js-newsletter-form");
    this.emailInput = this.querySelector(".js-attentive-email");
    this.emailError = this.querySelector(".js-attentive-email-error");
    this.phoneInput = this.querySelector(".js-attentive-phone");
    this.phoneError = this.querySelector(".js-attentive-phone-error");
    this.mainContent = this.querySelector(".js-attentive-main-form");
    this.successMessage = this.querySelector(".js-attentive-success");
    this.cancel = this.querySelector(".js-attentive-cancel");
    this.closeButton = document.querySelector(".js-attentive-close-modal");
    this.popupElement = document.querySelector(".js-attentive-details-disclosure");
    this.wholeElement = document.querySelector(".js-attentive-section");

    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.cancel.addEventListener("click", this.handleCancel.bind(this));
    this.closeButton.addEventListener("click", this.handleClose.bind(this));

    this.checkCookie();
  }

  checkCookie() {
    if (getCookie("submitAttentive") || getCookie("hideAttentive")) {
      this.wholeElement.remove();
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const serialized = JSON.parse(serializeForm(this.form));

    if (serialized.email != "" && !validateEmail(serialized.email)) {
      this.emailInput.focus();
      this.emailInput.setAttribute("aria-invalid", "true");
      this.emailInput.setAttribute("aria-describedby", this.emailError);
      this.emailError.classList.remove("hidden")
    } else {
      this.emailInput.setAttribute("aria-invalid", "false");
      this.emailInput.removeAttribute("aria-describedby");
      this.emailError.classList.add("hidden")
    }

    if (serialized.phone != "" && !validatePhone(serialized.phone)) {
      this.phoneInput.focus();
      this.phoneInput.setAttribute("aria-invalid", "true");
      this.phoneInput.setAttribute("aria-describedby", this.phoneError);
      this.phoneError.classList.remove("hidden")
    } else {
      this.phoneInput.setAttribute("aria-invalid", "false");
      this.phoneInput.removeAttribute("aria-describedby");
      this.phoneError.classList.add("hidden")
    }

    if (!serialized.hasOwnProperty("consent")) {
      // show consent error
    }


    // if email is full or if phone is full AND email is valid or phone is valid AND has consent
    if ((serialized.email != "" || serialized.phone != "")
      && (validateEmail(serialized.email) || validatePhone(serialized.phone))
      && serialized.hasOwnProperty("consent")) {
        const body = JSON.stringify(serialized);

        fetch("https://kv3pq8wy47.execute-api.us-east-1.amazonaws.com/dev/mavi-api-dev-attentive", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body
        })
          .then(resp => resp.json())
          .then((resp) => {
            if (resp.response.error == "Bad Request" && resp.response.message.indexOf("not valid for company country" > -1)) {
              this.phoneError.innerText = "Invalid phone number for this country";
              this.phoneError.classList.remove("hidden");
            } else {
              this.mainContent.classList.add("hidden");
              this.successMessage.classList.remove("hidden");
            }
            // setCookie("submitAttentive", "submitted");
          })
          .catch(() => {
            // show submission error message
          })
    }
  }

  handleCancel() {
    this.popupElement.removeAttribute("open");
  }

  handleClose() {
    this.wholeElement.remove();
    if (!getCookie("attentiveSubmit")) {
      setCookie("hideAttentive", "true", 7)
    }
  }
}

customElements.define("newsletter-form", Newsletter);
